var chatService = function () {
  this.getAllMessages = function (context, contextUid) {
    var user = JSON.parse(window.localStorage.getItem("super-app-user"));
    return new Promise(function (resolve, reject) {
      // window.fetch(`http://localhost:3000/api/chat/context/${context}/context_uid/${contextUid}`, {
      window.fetch(`https://rdpparseplataformapi.azurewebsites.net/api/chat/context/${context}/context_uid/${contextUid}`, {
        method: "GET"
      }).then(function(response) {
        return response.json();
      }).then(function(data) {
        resolve(data)
      }, function (error) {
        reject(error);
      });
    })
  }

  this.post = function (context, contextUid, userUid, userName, message) {
    return new Promise(function (resolve, reject) {
      // window.fetch(`http://localhost:3000/api/chat/new`, {
      window.fetch(`https://rdpparseplataformapi.azurewebsites.net/api/chat/new`, {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          "context": context,
          "context_uid": contextUid,
          "user_uid": userUid,
          "user_name": userName,
          "message": message
        })
      }).then(function(response) {
        return response.json();
      }).then(function(data) {
        resolve(data)
      }, function (error) {
        reject(error);
      });
    })
  }

  return this;
}

var ChatService = new chatService();

export {
  ChatService
};